import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Epic%20sports%20stadium%20panorama%20at%20night%20with%20dramatic%20stadium%20lights%20illuminating%20the%20field%2C%20grand%20sports%20arena%20architecture%2C%20atmospheric%20and%20cinematic%20composition%2C%20professional%20sports%20photography%20style%2C%20warm%20golden%20and%20crimson%20lighting%20tones%2C%20no%20text%20no%20logos&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="九游体育赛事平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight max-w-4xl">
          专业体育赛事平台
        </h1>
        <p className="mt-5 md:mt-6 text-base md:text-lg text-background-200 max-w-2xl leading-relaxed">
          汇聚全球顶级赛事直播、深度数据分析与最新体育资讯，为每一位体育爱好者打造极致的观赛体验
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4 mt-8">
          <Link
            to="/category/football"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            查看赛事直播
          </Link>
          <a
            href="#news"
            className="px-8 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 font-semibold text-sm md:text-base hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap"
          >
            浏览体育资讯
          </a>
        </div>

        <div className="mt-10 md:mt-14 flex items-center gap-6 md:gap-10">
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-accent-400">12,800+</p>
            <p className="text-xs md:text-sm text-background-300 mt-1">赛事直播</p>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-accent-400">3,200万</p>
            <p className="text-xs md:text-sm text-background-300 mt-1">活跃用户</p>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-accent-400">50万+</p>
            <p className="text-xs md:text-sm text-background-300 mt-1">数据模型</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <a href="#live" className="flex flex-col items-center gap-2 text-background-50/60 hover:text-background-50 transition-colors duration-200 cursor-pointer">
          <span className="text-xs">向下滚动</span>
          <i className="ri-arrow-down-s-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}